'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.prepareCall = void 0;
function prepareCall(target) {
    return target instanceof Array ? target : [this, target];
}
exports.prepareCall = prepareCall;
